import { useEffect as c } from "react";
const p = (f, s, t) => {
  c(
    () => {
      s !== t && t && (f == null || f(t));
    },
    [f, s, t]
  );
};
export {
  p as default
};
